export default {
    allClients: null,
    clientDetails: null,
    totalClients: {
        totalItems: null,
        totalPages: null,
    },
};
